import { CardBody, Collapse } from "reactstrap";
import { Image } from "../../../../../AbstractElements";
import { dynamicImage } from "../../../../../Service/DynamicImage";
import { MyProfileClassCollapseProp } from "../../../../../Type/SocialAppType";

const LatestPhotosCollapse = ({ isFilter }: MyProfileClassCollapseProp) => {
  const numbers:number[] = [1, 2, 3, 4, 5, 6, 7, 8];
  
  return (
    <Collapse isOpen={isFilter}>
      <CardBody className="photos filter-cards-view">
        <ul className="text-center">
          {numbers.map((data, index) => (
            <li key={index}>
              <div className="latest-post">
                <Image className="img-fluid" alt="user" src={dynamicImage(`social-app/post-${data}.png`)}/>
              </div>
            </li>
          ))}
        </ul>
      </CardBody>
    </Collapse>
  );
};

export default LatestPhotosCollapse;
